var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResume5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.025 21q-.425 0-.713-.288-.287-.287-.287-.712t.287-.712Q3.6 19 4.025 19h16q.425 0 .713.288.287.287.287.712t-.287.712q-.288.288-.713.288ZM5.6 15.8q-.325.1-.625-.025T4.5 15.35l-1.9-3.225q-.25-.4-.087-.75.162-.35.637-.45.175-.05.4.025.225.075.35.2l1.425 1.25 4.8-1.3L6.75 5.375q-.275-.475-.1-.913.175-.437.7-.612.275-.1.625-.013.35.088.575.288L14.875 9.8l5-1.35q.8-.2 1.45.325.65.525.65 1.375 0 .55-.337.975-.338.425-.863.575Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume5);
export default __webpack_public_path__ + "static/media/resume5.c05d35ed5207bb9862516f7942502999.svg";
export { ForwardRef as ReactComponent };